import { Outlet, Route } from "react-router-dom";
import { ShowProvider } from "../../../providers";
import { CommentatorsPage } from "../CommentatorsPage";
import { CommentatorsCreate } from "../CommentatorsCreate";
import { CommentatorShow } from "../CommentatorShow";

const CommentatorsRoutes = [
  <Route key={"commentators"} path="commentators" element={<Outlet />}>
    <Route
      index
      element={
        <ShowProvider>
          <CommentatorsPage />
        </ShowProvider>
      }
    />
    <Route
      key={"commentatorsCreate"}
      path="create"
      element={
        <ShowProvider>
          <CommentatorsCreate />
        </ShowProvider>
      }
    />
    <Route
      key={"commentatorsShowId"}
      path=":id"
      element={
        <ShowProvider>
          <CommentatorShow />
        </ShowProvider>
      }
    />
  </Route>,
];

export const COMMENTATORS_ROUTES = CommentatorsRoutes.map((route) => route);
